import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreNumber } from '../../ParseHelper';
import { BoosterType, createAnyBoostersRecord } from '../../../State/Card/BoosterType';
import { RewardType } from '../../../Utility/Rewards/RewardType';
import { MAX_COINS, MAX_KEYS, MAX_WHEEL_SPINS, MAX_FREE_CHESTS } from '../../../Constants/Player';
import { newPlayerCurrencyAmount } from '../../../Constants/Economy';
import { MathHelper } from '../../../Utility/MathHelper';
import { initialPlayerInventory } from '../../../State/Player/initialPlayerStates';

type PlayerStateKey = 'inventory';
type PlayerDataKeys =
    | BoosterType
    | RewardType.FREE_PLAY
    | RewardType.PREMIUM_SPIN
    | 'coins'
    | 'keys'
    | 'wheelSpins'
    | 'freeChest'
    | RewardType.PLINKO_TOKEN;
export default class Inventory implements PlayerProperty<PlayerStateKey, PlayerDataKeys> {
    public isChanged(playerStateData: IPlayerState, playerEndpointData: IPlayerData): boolean {
        const restoreData = this.restore(playerEndpointData);
        return (
            Object.values(createAnyBoostersRecord(boosterType => boosterType)).some(boosterType => {
                return restoreData[boosterType] !== playerStateData.inventory[boosterType];
            }) ||
            restoreData[RewardType.FREE_PLAY] !== playerStateData.inventory[RewardType.FREE_PLAY] ||
            restoreData.coins !== playerStateData.inventory.coins ||
            restoreData.keys !== playerStateData.inventory.keys ||
            restoreData.wheelSpins !== playerStateData.inventory.wheelSpins ||
            restoreData.shopGift !== playerStateData.inventory.shopGift ||
            restoreData[RewardType.PREMIUM_SPIN] !== playerStateData.inventory[RewardType.PREMIUM_SPIN] ||
            restoreData[RewardType.PLINKO_TOKEN] !== playerStateData.inventory[RewardType.PLINKO_TOKEN]
        );
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        return {
            ...createAnyBoostersRecord(boosterType =>
                restoreNumber(playerEndpointData[boosterType], initialPlayerInventory[boosterType] ?? 0)
            ),
            [RewardType.FREE_PLAY]: restoreNumber(playerEndpointData[RewardType.FREE_PLAY], 0),
            [RewardType.PREMIUM_SPIN]: restoreNumber(playerEndpointData[RewardType.PREMIUM_SPIN], 0),
            coins: MathHelper.clamp(restoreNumber(playerEndpointData.coins, newPlayerCurrencyAmount), 0, MAX_COINS),
            keys: MathHelper.clamp(restoreNumber(playerEndpointData.keys, 0), 0, MAX_KEYS),
            wheelSpins: MathHelper.clamp(restoreNumber(playerEndpointData.wheelSpins, 0), 0, MAX_WHEEL_SPINS),
            shopGift: MathHelper.clamp(restoreNumber(playerEndpointData.freeChest, 1), 0, MAX_FREE_CHESTS),
            [RewardType.PLINKO_TOKEN]: restoreNumber(playerEndpointData[RewardType.PLINKO_TOKEN], 0),
        };
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            ...createAnyBoostersRecord(boosterType => playerStateData.inventory[boosterType]),
            [RewardType.FREE_PLAY]: playerStateData.inventory[RewardType.FREE_PLAY],
            [RewardType.PREMIUM_SPIN]: playerStateData.inventory[RewardType.PREMIUM_SPIN],
            coins: playerStateData.inventory.coins,
            keys: playerStateData.inventory.keys,
            wheelSpins: playerStateData.inventory.wheelSpins,
            freeChest: playerStateData.inventory.shopGift,
            [RewardType.PLINKO_TOKEN]: playerStateData.inventory[RewardType.PLINKO_TOKEN],
        };
    }
}
